import { Button } from 'components/atoms';
import { useTranslation } from 'react-i18next';
import { PiList, PiSquaresFour } from 'react-icons/pi';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { useListViewById } from 'hooks/useListViewById';

interface IViewToggleButtonProps {
  id: string;
  defaultView?: 'grid' | 'list';
}

const ViewToggleButton = ({ id, defaultView = 'grid' }: IViewToggleButtonProps) => {
  const { t } = useTranslation();
  const { view, toggleView } = useListViewById(id, defaultView);

  return (
    <Button onlyIcon variant={BUTTON_VARIANT.default} onClick={toggleView} isClear>
      <Button.Icon icon={view === 'grid' ? <PiList /> : <PiSquaresFour />} />
      <Button.Description
        description={view === 'grid' ? t('button.changeToListView') : t('button.changeToGridView')}
      />
    </Button>
  );
};

export default ViewToggleButton;
